import {
  AppleIcon,
  CheckIcon,
  FileIcon2,
  PersonArmsUpIcon,
  PersonExclamationIcon,
  PersonIcon1,
  ProfileIcon1,
  StarIcon,
  TeamIcon,
  TrainerRatingIcon,
  TrendingDown,
  TrendingUp,
  WorkoutIcon,
} from "../../../images/icons/icons";
import { getCardIcon } from "../../common-data/Conversions";
import { getTrialsIcon } from "../../pt-trials/member-report/MemberReportMocks";

export const memberProfileTabs = [
  {
    label: "Profile",
    value: "member-profile",
    icon: <ProfileIcon1 />,
  },
  {
    label: "Fitness Profile",
    value: "fitness-profile",
    icon: getTrialsIcon(),
  },
  {
    label: "BCA Profile",
    value: "bca-profile",
    icon: <FileIcon2 />,
  },
  {
    label: "PT Trial",
    value: "pt-trial",
    icon: <PersonArmsUpIcon />,
  },
  {
    label: "Membership",
    value: "membership",
    icon: <TeamIcon />,
  },
  {
    label: "Checkins",
    value: "checkins",
    icon: getCardIcon("total_checkin"),
  },
  {
    label: "Workouts",
    value: "workouts",
    icon: <WorkoutIcon />,
  },
  {
    label: "Trainer Rating",
    value: "trainer-rating",
    icon: <TrainerRatingIcon />,
  },
  {
    label: "Progress",
    value: "member-progress",
    icon: <TrendingUp />,
  },
  {
    label: "Attendance",
    value: "attendance",
    icon: <PersonIcon1 />,
  },
  {
    label: "Nutrition",
    value: "nutrition",
    icon: <AppleIcon />,
  },
];

// TME Attendance Analysis Mock Data
export const tmeAttendanceAnalysisMockData = {
  summary: {
    bothPresent: {
      days: 19,
      percentage: 63,
      total: 30,
    },
    workoutTracked: {
      days: 15,
      percentage: 79,
      total: 30,
    },
    avgRating: {
      rating: 4.6,
      maxRating: 5,
    },
    totalDays: {
      days: 30,
      label: "tracked",
    },
  },
  checkinBreakdown: {
    memberOnly: {
      days: 3,
      description: "Member checked in, trainer absent",
    },
    trainerOnly: {
      days: 8,
      description: "Trainer present, member absent",
    },
    neitherPresent: {
      days: 0,
      description: "Both absent",
    },
    perfectAlignment: {
      days: 15,
      description: "Both present + workout logged",
    },
  },
  timeline: [
    {
      date: "Tue, Oct 14",
      workoutTracked: true,
      member: {
        present: true,
        time: "13:00 AM",
      },
      trainer: {
        present: true,
        time: "17:30 AM",
      },
      workout: {
        logged: true,
        type: "Yoga",
        duration: 87,
      },
      rating: 5,
    },
    {
      date: "Mon, Oct 13",
      workoutTracked: false,
      member: {
        present: false,
        time: null,
      },
      trainer: {
        present: true,
        time: "15:30 PM",
      },
      workout: {
        logged: false,
        type: null,
        duration: null,
      },
      rating: null,
    },
    {
      date: "Sun, Oct 12",
      workoutTracked: false,
      member: {
        present: false,
        time: null,
      },
      trainer: {
        present: true,
        time: "9:00 PM",
      },
      workout: {
        logged: false,
        type: null,
        duration: null,
      },
      rating: null,
    },
    {
      date: "Sat, Oct 11",
      workoutTracked: false,
      member: {
        present: true,
        time: "17:45 PM",
      },
      trainer: {
        present: false,
        time: null,
      },
      workout: {
        logged: false,
        type: null,
        duration: null,
      },
      rating: null,
    },
    {
      date: "Fri, Oct 10",
      workoutTracked: true,
      member: {
        present: true,
        time: "10:45 AM",
      },
      trainer: {
        present: true,
        time: "17:15 AM",
      },
      workout: {
        logged: true,
        type: "Strength Training",
        duration: 32,
      },
      rating: 5,
    },
  ],
  insights: [
    {
      type: "strong-alignment",
      icon: "check",
      title: "Strong Alignment",
      description:
        "Member and trainer were both present on 19 out of 30 days (63% alignment rate)",
      variant: "success",
    },
    {
      type: "high-satisfaction",
      icon: "star",
      title: "High Satisfaction",
      description:
        "Average rating of 4.6 stars indicates excellent member satisfaction",
      variant: "warning",
    },
  ],
};

// TME Chart Analysis Mock Data (Member Progress)
export const tmeChartAnalysisMockData = {
  progressData: {
    weight: {
      start: 66.4,
      current: 63.1,
      change: "-3.3",
    },
    bmi: {
      start: 23.0,
      current: 21.8,
      change: "-1.2",
    },
    bca: {
      start: "2.8%",
      latest: "6.4%",
      change: "+3.6",
    },
  },
  weightComparison: {
    categories: ["Day 1", "Day 8", "Day 15", "Day 22"],
    data: [66.4, 65.1, 64.4, 63.1],
    yAxisMin: 61.1,
    yAxisMax: 68.4,
    logs: [
      { day: "Day 1", value: "66.4 kg", change: null, changeType: null },
      {
        day: "Day 8",
        value: "65.1 kg",
        change: "-1.3",
        changeType: "negative",
      },
      {
        day: "Day 15",
        value: "64.4 kg",
        change: "-0.7",
        changeType: "negative",
      },
      {
        day: "Day 22",
        value: "63.1 kg",
        change: "-1.3",
        changeType: "negative",
      },
    ],
  },
  bmiComparison: {
    categories: ["Day 1", "Day 8", "Day 15", "Day 22"],
    data: [23.0, 22.5, 22.3, 21.8],
    yAxisMin: 21.6,
    yAxisMax: 24.0,
    logs: [
      { day: "Day 1", value: "23.0", change: null, changeType: null },
      { day: "Day 8", value: "22.5", change: "-0.5", changeType: "negative" },
      { day: "Day 15", value: "22.3", change: "-0.2", changeType: "negative" },
      { day: "Day 22", value: "21.8", change: "-0.5", changeType: "negative" },
    ],
  },
  bcaComparison: {
    categories: ["BCA 1", "BCA 2", "BCA 3"],
    data: [2.8, 4.4, 6.4],
    yAxisMin: 1.6,
    yAxisMax: 7.6,
    logs: [
      { day: "BCA 1", date: "2025-09-16", value: "2.8%", change: null },
      { day: "BCA 2", date: "2025-09-30", value: "4.4%", change: "+1.6%" },
      { day: "BCA 3", date: "2025-10-14", value: "6.4%", change: "+2.0%" },
    ],
  },
  goalAssessment: {
    memberGoal: "Weight Loss",
    status: "In Progress",
    weightLost: "1.6 kg",
    startDate: "2025-09-01",
    targetDate: "2025-12-31",
    progressPercentage: 60,
    additionalGoals: [
      {
        id: 1,
        goal: "Weight Loss",
        target: "Lose 5kg",
        current: "Lost 3.2kg",
        status: "In Progress",
        progress: 64,
        color: "#10b981",
      },
      {
        id: 2,
        goal: "Build Muscle",
        target: "Gain 3kg muscle mass",
        current: "Gained 1.8kg",
        status: "In Progress",
        progress: 60,
        color: "#3b82f6",
      },
      {
        id: 3,
        goal: "Improve Flexibility",
        target: "Touch toes comfortably",
        current: "6 inches from toes",
        status: "In Progress",
        progress: 40,
        color: "#f59e0b",
      },
      {
        id: 4,
        goal: "Reduce Body Fat %",
        target: "18% body fat",
        current: "20.7% body fat",
        status: "In Progress",
        progress: 55,
        color: "#8b5cf6",
      },
    ],
    milestones: [
      {
        title: "First Month Complete",
        date: "2025-10-01",
        achieved: true,
        description: "Completed 20 workout sessions",
      },
      {
        title: "Halfway Point",
        date: "2025-11-15",
        achieved: false,
        description: "Target: 40 workout sessions",
      },
      {
        title: "Goal Achievement",
        date: "2025-12-31",
        achieved: false,
        description: "Complete all fitness goals",
      },
    ],
    insights: [
      {
        type: "positive",
        icon: "check",
        title: "Excellent Attendance",
        description:
          "Member is consistently attending 4-5 classes per week, exceeding the recommended 3 sessions",
      },
      {
        type: "warning",
        icon: "alert",
        title: "Nutrition Focus Needed",
        description:
          "To achieve weight loss goals faster, consider reviewing nutritional habits with a dietitian",
      },
      {
        type: "info",
        icon: "info",
        title: "Progress Trending Up",
        description:
          "All metrics show positive improvement over the last 30 days",
      },
    ],
    trainerNotes: [
      {
        date: "2025-10-14",
        trainer: "John Smith",
        note: "Member showing great improvement in cardio endurance. Suggested increasing intensity.",
      },
      {
        date: "2025-10-01",
        trainer: "John Smith",
        note: "Initial assessment completed. Member is motivated and ready to work hard.",
      },
    ],
  },
};

export const tmeAnalysisDetailedMockData = {
  activeMembers: {
    count: 42,
    label: "Active Members",
    icon: "users",
  },
  lostMembers: {
    count: 8,
    label: "Lost Members",
    icon: "trending-down",
  },
  rating: {
    value: 4.8,
    maxRating: 5,
    label: "Rating",
    icon: "award",
  },
  totalMembers: {
    count: 50,
    label: "Total Members",
    icon: "team",
  },
};

export const getCardTitle = (key) => {
  const titles = {
    total_members: "Total Members",
    total_active_members: "Active Members",
    total_expired_members: "Lost Members",
    current_trainer_avg_rating: "Trainer Rating",
  };
  return titles[key] || key?.replace(/_/g, " ");
};

export const getCardValue = (key, value) => {
  switch (key) {
    case "trainer_attendance":
      return `${value?.present || 0}/${value?.total || 0}`;
    default:
      return value || 0;
  }
};

export const getCardIconType = (key) => {
  switch (key) {
    case "total_active_members":
    case "workout_tracked":
    case "active_trainers":
    case "active_members":
      return "success";
    case "current_trainer_avg_rating":
    case "avg_rating":
    case "trainer_avg_utilization":
    case "retention_rate":
      return "warning";
    case "unassigned":
    case "total_expired_members":
    case "total_days":
    case "expired_members":
      return "danger";
    default:
      return "info";
  }
};

export const getCardsIcon = (key) => {
  switch (key) {
    case "total_members":
      return <TeamIcon />;
    case "total_expired_members":
      return <TrendingDown />;
    case "current_trainer_avg_rating":
    case "avg_rating":
      return <StarIcon />;
    case "workout_tracked":
      return <WorkoutIcon />;
    case "total_days":
      return <CheckIcon />;
    case "expired_members":
      return <PersonExclamationIcon />;
    case "retention_rate":
      return <CheckIcon />;
    default:
      return getCardIcon("total_checkin");
  }
};

export const getBackgroundColor = (key) => {
  switch (key) {
    case "member_only":
      return "#eff6ff"; // light blue
    case "trainer_only":
      return "#fefce8"; // light yellow
    case "neither_present":
      return "#f9fafb"; // light gray
    case "perfect_alignment":
      return "#f0fdf4"; // light green
    default:
      return "#ffffff";
  }
};

export const getBadgeColor = (key) => {
  switch (key) {
    case "member_only":
      return "#1f2937"; // dark
    case "trainer_only":
      return "#1f2937"; // dark
    case "neither_present":
      return "#6b7280"; // gray
    case "perfect_alignment":
      return "#10b981"; // green
    default:
      return "#1f2937";
  }
};
